import { MouseEventHandler } from 'react'
import { Button } from './styles'
import Icon from 'components/shared/Icon'

const CustomButton = ({
    isDisabled,
    onClick,
    direction,
    testId,
    hasDarkMode,
}: {
    isDisabled: boolean
    onClick: MouseEventHandler<Element> | undefined
    direction: '-prev' | '-next'
    testId?: string
    hasDarkMode?: boolean
}) => {
    const activeColor = hasDarkMode ? 'grayscale_500' : 'primary_500'
    const disabledColor = hasDarkMode ? 'grayscale_700' : 'grayscale_400'

    return (
        <Button
            onClick={onClick}
            disabled={isDisabled}
            className={direction}
            data-testid={testId}
            tabIndex={0}
        >
            <Icon
                variant="chevron"
                color={isDisabled ? disabledColor : activeColor}
                rotation={direction === '-next' ? -90 : 90}
            />
        </Button>
    )
}

export default CustomButton
